import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import colorModel from './colorModel.vue';
export default {
  components: {
    colorModel
  },
  props: {
    styleObj: {
      type: Object,
      default() {
        return {};
      }
    },
    pageTitle: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      form: {},
      searchCheckedList: [],
      chooseQuery: [],
      colorShow: false,
      btnIdx: ''
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.form = this.styleObj;
      this.searchCheckedList = this.form.searchTerms.map(item => {
        if (item.termDisplay) {
          return item.termValue;
        }
      });
      this.chooseQuery = this.searchCheckedList;
    });
  },
  methods: {
    queryChange(val) {
      console.log(val);
      if (this.searchCheckedList.length != 0) {
        this.chooseQuery = this.searchCheckedList;
        this.form.searchTerms.forEach(item => {
          if (this.chooseQuery.includes(item.termValue)) {
            item.termDisplay = true;
          } else {
            item.termDisplay = false;
          }
        });
      } else {
        this.$message.warning(this.$t('至少选一个筛选条件'));
        this.searchCheckedList = this.chooseQuery;
      }
    },
    changeFun() {
      this.$emit('itemChange', this.form);
    },
    colorClickFun(idx, val, key) {
      this.colorShow = true;
      this.btnIdx = idx;
      this.$nextTick(() => {
        this.$refs.colorRef.init(val, key);
      });
    },
    colorFun(val, key) {
      this.form.buttonInfo.buttons[this.btnIdx][key] = val;
      this.changeFun();
      this.colorShow = false;
    }
  }
};